"use strict";
var Observable_1 = require('../../Observable');
var publish_1 = require('../../operator/publish');
Observable_1.Observable.prototype.publish = publish_1.publish;
//# sourceMappingURL=publish.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/publish.js
 ** module id = 538
 ** module chunks = 2
 **/